const formatTime = (time: number): string =>
  time < 10 ? `0${time}` : String(time);

const formatTimeString = (
  template: string,
  values: Record<string, string>,
): string => {
  return template.replace(/\{(\w+)\}/g, (_, key) => {
    return values[key] ?? `{${key}}`;
  });
};

const milisecondsToTime = (
  miliseconds: number,
): { seconds: string; minutes: string; hours: string; days: string } => {
  const seconds = Math.round(miliseconds / 1000);
  const minutes = Math.round((seconds - (seconds % 60)) / 60);
  const hours = Math.round((minutes - (minutes % 60)) / 60);
  let days = 0;

  if (hours >= 24) {
    days = Math.round((hours - (hours % 24)) / 24);
  }

  const secondsResult = seconds % 60;
  const minutesResult = minutes % 60;
  const hoursResult = hours % 24;

  return {
    seconds: formatTime(secondsResult),
    minutes: formatTime(minutesResult),
    hours: formatTime(hoursResult),
    days: formatTime(days),
  };
};

const timeStringFormat = (
  miliseconds: number,
  options?: { template?: string },
): string => {
  const time = milisecondsToTime(miliseconds);
  const { seconds, minutes, hours } = time;

  if (options?.template) {
    return formatTimeString(options.template, time);
  }

  return `${hours}:${minutes}:${seconds}`;
};

const timeStringFormatShortForm = (
  miliseconds: number,
  removeZero?: boolean,
): string => {
  const time = milisecondsToTime(miliseconds);
  const { minutes, hours, days } = time;

  return Number(days)
    ? `${removeZero ? Number(days) : days}d : ${hours}h`
    : `${removeZero ? Number(hours) : hours}h : ${minutes}m`;
};

export {
  formatTime,
  milisecondsToTime,
  timeStringFormat,
  timeStringFormatShortForm,
};
